export default __webpack_public_path__ + "static/media/footerEfacilitiLogo.08d29f3c.svg";